import { CircleFilledChip, RenewIcon } from '../../../../components/buttons/IconButtons';
import CustomTooltip from '../../../../components/CustomTooltip';
import CustomUserChip from '../../../../components/CustomUserChip';
import { POSITION_MODEL } from '../../../../Helpers/PositionModel';
import ConnectionStatusApp from "../../DiningKitchen/Functionality/ConnectionStatusApp";
/**
 * @Author: Susana García Rodríguez
 * @JobTitle : Frontend
 * @Email : sgarcia@ibl.mx
 *
 * @param boolean isOnline: Variable that indicates whether the WebSocket is open
 */
const ConnectionStatus = ({ isOnline, setModified, showStatus }) => {
    const {
        t,
        hour,
        dateFormat
    } = ConnectionStatusApp();

    const statusText = isOnline ? 'online' : 'offline';
    const chipClass = isOnline ? 'chip-success-150-100' : 'chip-error-code-150-100';

    return (
        <div className='d-flex align-items-center gap-3'>
            {showStatus &&
                <>
                    <p className='fs-16px ibl-font-w-500 font-color-general-950'>{t('status') + ':'}</p>
                    <CustomUserChip
                        className={`mt-0 mx-0 px-0 text-nowrap ${chipClass}`}
                        variant={'large'}
                        Icon={CircleFilledChip}
                        showAvatar={true}
                        name={t(statusText)}
                        iconPosition={POSITION_MODEL.LEFT}
                        classNameIcon={'icon-color-primary-700'}
                    />
                </>
            }

            <div
                className={`icon-color-shades-400 w-40px h-24px ${isOnline ? 'cursor-not-allowed' : 'cursor-pointer icon-hover-shades-950'}`}
            >
                <CustomTooltip text={!isOnline && t('renew')}>
                    <RenewIcon
                        width={40}
                        height={24}
                        onClick={() => {
                            if (!isOnline) setModified(true);
                        }}
                    />
                </CustomTooltip>
            </div>

            <div className='d-flex align-items-center gap-4 w-100'>
                <p className='fs-20px ibl-font-w-300 font-color-general-950'>{dateFormat}</p>
                <p className='fs-20px ibl-font-w-300 font-color-general-950 text-container-clock'>
                    {hour.format('HH:mm:ss')}
                </p>
            </div>
        </div>
    );
};

export default ConnectionStatus;
